import React from 'react';

export default function Loader() {
    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M15 8C15.5523 8 16.0064 8.44945 15.9376 8.99743C15.77 10.3309 15.2684 11.6064 14.4721 12.7023C13.4791 14.0691 12.0789 15.0864 10.4721 15.6085C8.86539 16.1305 7.13461 16.1305 5.52786 15.6085C3.92112 15.0864 2.52089 14.0691 1.52786 12.7023C0.534839 11.3355 -1.47695e-07 9.68943 0 8C1.47695e-07 6.31057 0.53484 4.6645 1.52786 3.29772C2.52089 1.93094 3.92112 0.913611 5.52786 0.391548C6.81621 -0.0270598 8.18429 -0.110014 9.50424 0.142684C10.0467 0.246531 10.3338 0.817351 10.1631 1.3426V1.3426C9.99245 1.86786 9.42802 2.14629 8.88173 2.06513C7.96881 1.92951 7.03219 2.00569 6.1459 2.29366C4.94084 2.68521 3.89067 3.4482 3.1459 4.47329C2.40113 5.49837 2 6.73292 2 8C2 9.26708 2.40113 10.5016 3.1459 11.5267C3.89067 12.5518 4.94084 13.3148 6.1459 13.7063C7.35096 14.0979 8.64904 14.0979 9.8541 13.7063C11.0592 13.3148 12.1093 12.5518 12.8541 11.5267C13.4019 10.7728 13.7637 9.90555 13.9169 8.9954C14.0085 8.45077 14.4477 8 15 8V8Z'
                fill='#2e4570'>
                <animateTransform
                    attributeName='transform'
                    attributeType='XML'
                    type='rotate'
                    dur='1s'
                    from='0 8 8'
                    to='360 8 8'
                    repeatCount='indefinite'
                />
            </path>
        </svg>
    );
}
